import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Features } from '@app/enums';
import { TranslationParamsPipe } from '@app/pipes/translation-params.pipe';
import { PlanType } from '@app/reducers/account/account-subscription.model';
import { TrackingService } from '@app/services/tracking.service';
import { FeatureService } from '@app/startup/feature.service';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui';
import { clsx } from 'clsx';

@Component({
  selector: 'sb-header-upgrade-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, TranslationParamsPipe, ButtonComponent, RouterModule],
  templateUrl: './sb-header-upgrade.component.html',
})
export class SBHeaderUpgradeButtonComponent {
  @HostBinding('class')
  public hostClasses = clsx('flex items-center gap-2');

  @Input({ required: true })
  public isConfirmedAccount: boolean;

  @Input({ required: true })
  public planType: PlanType;

  @Input()
  public showRemainingDays = false;

  @Input({ required: true })
  public remainingDays: number;

  public PlanType = PlanType;

  public constructor(
    private featureService: FeatureService,
    private router: Router,
    private trackingService: TrackingService,
  ) {}

  public openPlanWizard(): void {
    if (this.featureService.isFeatureActivated(Features.TMP_ONBOARDING_VARIATION_V10) && !this.isConfirmedAccount) {
      this.trackingService.event('Experiment Viewed', {
        experiment_id: 'Checkout Confirm Plan Flow v1',
        variation_id: 'treatment',
      });

      this.router.navigate(['', { outlets: { modal: ['subscription'] } }]);
    } else {
      this.trackingService.event('Experiment Viewed', {
        experiment_id: 'Checkout Confirm Plan Flow v1',
        variation_id: 'control',
      });

      // originator is used for tracking the origin of the user's action to the plan wizard
      this.router.navigate(['account', 'billing', { originator: 'btn-header', open: 'plan-wizard' }]);
    }
  }
}
